/**
 * Relative date-range presets for HazardAI scheduled panel reports.
 *
 * The token is stored in Report.filters.dateRange and resolved to concrete
 * YYYY-MM-DD boundaries (in the company's timezone) at report-generation time
 * by the backend's resolveRelativeDateRange() helper.
 *
 * Keep in sync with backend/src/services/Helper/date.ts — HazardAIDateRangePreset.
 */

export type DateRangePreset =
  | 'today'
  | 'yesterday'
  | 'last_7_days'
  | 'last_30_days'
  | 'this_week'
  | 'last_week'
  | 'this_month'
  | 'last_month'
  | 'custom';

export const DATE_RANGE_PRESETS: Array<{value: DateRangePreset; label: string}> = [
  {value: 'today', label: 'Today'},
  {value: 'yesterday', label: 'Yesterday'},
  {value: 'last_7_days', label: 'Last 7 Days'},
  {value: 'last_30_days', label: 'Last 30 Days'},
  {value: 'this_week', label: 'This Week (Mon–Sun)'},
  {value: 'last_week', label: 'Last Week (Mon–Sun)'},
  {value: 'this_month', label: 'This Month'},
  {value: 'last_month', label: 'Last Month'},
  {value: 'custom', label: 'Custom (fixed dates)'},
];

export const DATE_RANGE_PRESET_LABELS: Record<DateRangePreset, string> =
  Object.fromEntries(DATE_RANGE_PRESETS.map(({value, label}) => [value, label])) as Record<
    DateRangePreset,
    string
  >;
